import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ClientCreationForm } from '../components/ClientCreationForm';
import { ClientCreationResponse } from '@digitaltattoo/types';
import { HelpIcon } from '../components/HelpIcon';

export function ComprehensiveClientCreatePage() {
  const navigate = useNavigate();

  const handleSuccess = (response: ClientCreationResponse) => {
    console.log('Comprehensive client creation successful:', response);
    // The form handles the success display internally
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="p-6">
      <div className="w-full">
        {/* Header */}
        <div className="mb-8 text-center">
          <button
            onClick={handleCancel}
            className="inline-flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors border border-gray-300 shadow-sm mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Retour au Tableau de Bord</span>
          </button>
          
          <h1 className="text-3xl font-display font-bold text-textPrimary mb-2 flex items-center justify-center space-x-2">
            <span>Créer un Compte Client Complet</span>
            <HelpIcon 
              docPath="05-gestion-clients#05-4-creation-complete" 
              tooltip="Documentation : Création complète d'un client"
            />
          </h1>
          <p className="text-textSecondary">
            Inscription complète avec toutes les informations requises
          </p>
        </div>

        {/* Comprehensive Client Creation Form */}
        <ClientCreationForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isBackoffice={true}
        />
      </div>
    </div>
  );
}